import React from 'react'
import type { DisplayRowConfig } from './types'

const DisplayRow = ({ row }: { row: DisplayRowConfig }) => {
  const borderClass = row.showBorder !== false ? 'sm:border-b border-gray-400 ' : ''
  const currentBorderClass = row.showBorder !== false ? 'border-b border-gray-400 ' : ''

  return (
    <>
      <div className={`${borderClass}not-empty-pb-6 sm:flex sm:items-center sm:h-16 pt-6 sm:pt-0 text-center sm:text-left sm:text-sm font-semibold sm:font-medium text-gray-700`}>
        <label>{row.label}</label>
      </div>
      <div className={`${borderClass}not-empty-pb-6 sm:flex sm:items-center sm:h-16 sm:px-6`}/>
      <div className={`${borderClass}not-empty-pb-6 sm:flex sm:items-center sm:h-16 sm:px-6`}/>
      <div className={`${currentBorderClass}not-empty-pb-6 sm:flex sm:items-center sm:h-16`}>
        <div className="flex justify-between items-center">
          <div className="flex-1 text-right sm:text-left">
            {row.value}
          </div>
        </div>
      </div>
    </>
  )
}

export default DisplayRow
